// extracted by mini-css-extract-plugin
export default {"root":"DkpHVY","list":"b34aHA","item":"so9fp4","info":"jDqTKC","itemIcon":"zOPfee","itemTitle":"p7MjwW","buttons":"nflEch","button":"jRdgke"};